import NavigationLayout from "../navigation/navigationLayout";
import FooterLayout from '../footer/footerLayout';
import SideNavigationComponent from '../../components/widgets/sideNavigationComponent';
import TabsComponent from '../../components/widgets/tabsComponent';
import { useTranslation } from "react-i18next";
import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import CaseStudyDetails from "./caseStudyDetailsLayout";
import tourTechData from '../../assets/data/caseStudies/tourTech.json';
import eduTechData from '../../assets/data/caseStudies/eduTech.json';
import iGamingTechData from '../../assets/data/caseStudies/iGamingTech.json';
import matchTechData from '../../assets/data/caseStudies/matchTech.json';
import playTechData from '../../assets/data/caseStudies/playTech.json';
import retailTechData from '../../assets/data/caseStudies/retailTech.json';
import mobilityTechData from '../../assets/data/caseStudies/mobilityTech.json';
import { useEffect } from "react";

const CaseStudiesLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const caseStudiesList = [
        {label: t('caseStudies.playTech'), children: <CaseStudyDetails data={playTechData}/>},
        {label: t('caseStudies.tourTech'), children: <CaseStudyDetails data={tourTechData}/>},
        {label: t('caseStudies.eduTech'), children: <CaseStudyDetails data={eduTechData}/>},
        {label: t('caseStudies.retailTech'), children: <CaseStudyDetails data={retailTechData}/>},
        {label: t('caseStudies.matchTech'), children: <CaseStudyDetails data={matchTechData}/>},
        {label: t('caseStudies.iGamingTech'), children: <CaseStudyDetails data={iGamingTechData}/>},
        {label: t('caseStudies.mobilityTech'), children: <CaseStudyDetails data={mobilityTechData}/>}
    ];

    const isLargeDevice = useMediaQuery(theme.breakpoints.up("lg"));

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavigationLayout />

            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pt: {xs: 15, md: 20, lg: 25}
                }}
            >
                <Stack
                    direction='row'
                    justifyContent='start'
                    alignItems='center'
                    px='5%'
                >
                    {
                        isLargeDevice
                        ?
                        <SideNavigationComponent list={caseStudiesList}/>
                        :
                        <TabsComponent list={caseStudiesList}/>
                    }
                </Stack>
            </Box>

            <FooterLayout />
        </>
    );
}

export default CaseStudiesLayout;